var items = {
  "block.minecraft.air": "pūrere",
  "block.minecraft.stone": "toka",
  "block.minecraft.granite": "kawikawi",
  "block.minecraft.polished_granite": "granite pai",
  "block.minecraft.diorite": "diorite",
  "block.minecraft.polished_diorite": "diorite titi",
  "block.minecraft.andesite": "andesite",
  "block.minecraft.polished_andesite": "andesite poropiti",
  "block.minecraft.grass_block": "tarutaru poraka",
  "block.minecraft.dirt": "paru",
  "block.minecraft.coarse_dirt": "kotahi dirt",
  "block.minecraft.podzol": "onemata",
  "block.minecraft.crimson_nylium": "whero nylium",
  "block.minecraft.warped_nylium": "waruhia nylium",
  "block.minecraft.cobblestone": "cobblestone",
  "block.minecraft.oak_planks": "nga papa whenua",
  "block.minecraft.spruce_planks": "whakakapuhia nga papa",
  "block.minecraft.birch_planks": "papa maaka",
  "block.minecraft.jungle_planks": "nga papa tere",
  "block.minecraft.acacia_planks": "nga papa riiki",
  "block.minecraft.dark_oak_planks": "nga papa takotoranga pouri",
  "block.minecraft.crimson_planks": "papa whero",
  "block.minecraft.warped_planks": "papa hapa",
  "block.minecraft.oak_sapling": "oak māhuri",
  "block.minecraft.spruce_sapling": "te puruhi mo māhuri",
  "block.minecraft.birch_sapling": "birch māhuri",
  "block.minecraft.jungle_sapling": "uru raau no māhuri",
  "block.minecraft.acacia_sapling": "hitimi māhuri",
  "block.minecraft.dark_oak_sapling": "te huringa kao pouri",
  "block.minecraft.bedrock": "maka tefito",
  "block.minecraft.sand": "onepū",
  "block.minecraft.red_sand": "kirikiri whero",
  "block.minecraft.gravel": "tuakirikiri",
  "block.minecraft.gold_ore": "gold ore",
  "block.minecraft.iron_ore": "tokahuke rino",
  "block.minecraft.coal_ore": "coal ore",
  "block.minecraft.nether_gold_ore": "maoro pepa tokakonganuku",
  "block.minecraft.oak_log": "rau paki",
  "block.minecraft.spruce_log": "whakaohohia te rango",
  "block.minecraft.birch_log": "rangahau birch",
  "block.minecraft.jungle_log": "rau iwi",
  "block.minecraft.acacia_log": "rau acacia",
  "block.minecraft.dark_oak_log": "pato raiona pouri",
  "block.minecraft.crimson_stem": "rakau whero",
  "block.minecraft.warped_stem": "kakau pakau",
  "block.minecraft.stripped_oak_log": "whakapai i nga raakau whawhai",
  "block.minecraft.stripped_spruce_log": "whakapakihia te raakau whakaheke",
  "block.minecraft.stripped_birch_log": "unuhia a birch log",
  "block.minecraft.stripped_jungle_log": "tuhia te acacia log",
  "block.minecraft.stripped_acacia_log": "tuhia te acacia log",
  "block.minecraft.stripped_dark_oak_log": "te kai wood wood",
  "block.minecraft.stripped_crimson_stem": "takakau kuti whero",
  "block.minecraft.stripped_warped_stem": "unuhia te war war putu",
  "block.minecraft.stripped_oak_wood": "unuhia te kai horoahi",
  "block.minecraft.stripped_spruce_wood": "unuhia te birch wood",
  "block.minecraft.stripped_birch_wood": "horoia te rauhere wao",
  "block.minecraft.stripped_jungle_wood": "tangohia te acacia wood",
  "block.minecraft.stripped_acacia_wood": "tangohia a dark oak wood",
  "block.minecraft.stripped_dark_oak_wood": "tangohia a dark oak wood",
  "block.minecraft.stripped_crimson_hyphae": "hukuhua crimson hyphae",
  "block.minecraft.stripped_warped_hyphae": "hyphae kua whawhai",
  "block.minecraft.oak_wood": "rākau oke",
  "block.minecraft.spruce_wood": "te puruhi mo wood",
  "block.minecraft.birch_wood": "birch wood",
  "block.minecraft.jungle_wood": "uru raau no wood",
  "block.minecraft.acacia_wood": "hitimi wood",
  "block.minecraft.dark_oak_wood": "dark oak wood",
  "block.minecraft.crimson_hyphae": "hyphae whero",
  "block.minecraft.warped_hyphae": "hypae kotiti",
  "block.minecraft.oak_leaves": "rau oki",
  "block.minecraft.spruce_leaves": "rau te puruhi",
  "block.minecraft.birch_leaves": "birch rau",
  "block.minecraft.jungle_leaves": "uru raau no rau",
  "block.minecraft.acacia_leaves": "hitimi rau",
  "block.minecraft.dark_oak_leaves": "dark oak rau",
  "block.minecraft.sponge": "hautai",
  "block.minecraft.wet_sponge": "te hautai maku",
  "block.minecraft.glass": "karaehe",
  "block.minecraft.lapis_ore": "lapis lazuli ore",
  "block.minecraft.lapis_block": "lapis lazuli poraka",
  "block.minecraft.dispenser": "dispenser",
  "block.minecraft.sandstone": "hōanga",
  "block.minecraft.chiseled_sandstone": "whaoa hōanga",
  "block.minecraft.cut_sandstone": "tapahia a sandstone",
  "block.minecraft.note_block": "tuhipoka poraka",
  "block.minecraft.powered_rail": "rail powered",
  "block.minecraft.detector_rail": "pūkimi rail",
  "block.minecraft.sticky_piston": "kōkeke hāpiapia",
  "block.minecraft.cobweb": "cobweb",
  "block.minecraft.grass": "karaihe",
  "block.minecraft.fern": "ponga",
  "block.minecraft.dead_bush": "mate bush",
  "block.minecraft.seagrass": "hauhuru",
  "block.minecraft.sea_pickle": "pikitiki moana",
  "block.minecraft.piston": "kōkeke",
  "block.minecraft.white_wool": "wūru mā",
  "block.minecraft.orange_wool": "wūru karaka",
  "block.minecraft.magenta_wool": "wūru mākurakura",
  "block.minecraft.light_blue_wool": "wūru ōrangitea",
  "block.minecraft.yellow_wool": "wūru kōwhai",
  "block.minecraft.lime_wool": "wūru kārikikōwhai",
  "block.minecraft.pink_wool": "wūru māwhero",
  "block.minecraft.gray_wool": "wūru kiwikiwi",
  "block.minecraft.light_gray_wool": "wūru kiwitea",
  "block.minecraft.cyan_wool": "wūru kārikiōrangi",
  "block.minecraft.purple_wool": "wūru tawa",
  "block.minecraft.blue_wool": "wūru kahurangi",
  "block.minecraft.brown_wool": "whero whero",
  "block.minecraft.green_wool": "wūru kākāriki",
  "block.minecraft.red_wool": "wūru whero",
  "block.minecraft.black_wool": "wūru pango",
  "block.minecraft.dandelion": "tawao",
  "block.minecraft.poppy": "pūpū",
  "block.minecraft.blue_orchid": "blue orchid",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "azure bluet",
  "block.minecraft.red_tulip": "whero tulip",
  "block.minecraft.orange_tulip": "orange tulip",
  "block.minecraft.white_tulip": "white tulip",
  "block.minecraft.pink_tulip": "pink tulipapapa",
  "block.minecraft.oxeye_daisy": "ko oxeye daisy",
  "block.minecraft.cornflower": "puawai rota",
  "block.minecraft.lily_of_the_valley": "tuhinga o mua",
  "block.minecraft.wither_rose": "riki mate",
  "block.minecraft.brown_mushroom": "harore parauri",
  "block.minecraft.red_mushroom": "harore whero",
  "block.minecraft.crimson_fungus": "harore piimona",
  "block.minecraft.warped_fungus": "harore i whakawahia",
  "block.minecraft.crimson_roots": "putake whero",
  "block.minecraft.warped_roots": "nga pakiaka koretake",
  "block.minecraft.nether_sprouts": "nether tupu",
  "block.minecraft.weeping_vines": "waina waina",
  "block.minecraft.twisting_vines": "waina kotiro",
  "block.minecraft.sugar_cane": "tōhuka",
  "block.minecraft.kelp": "kakau",
  "block.minecraft.bamboo": "pūpū",
  "block.minecraft.gold_block": "poraka o kōura",
  "block.minecraft.iron_block": "poraka o rino",
  "block.minecraft.oak_slab": "huka kiri",
  "block.minecraft.spruce_slab": "whakatau riki",
  "block.minecraft.birch_slab": "papanga birch",
  "block.minecraft.jungle_slab": "taputapu huna",
  "block.minecraft.acacia_slab": "tapapa acacia",
  "block.minecraft.dark_oak_slab": "pouri kiri",
  "block.minecraft.crimson_slab": "tapawhuru",
  "block.minecraft.warped_slab": "papa iukiruki",
  "block.minecraft.stone_slab": "papu kowhatu",
  "block.minecraft.smooth_stone_slab": "he kowhatu kowhatu kohatu",
  "block.minecraft.sandstone_slab": "mahara peariki",
  "block.minecraft.cut_sandstone_slab": "tapahia te tapahi sandstone",
  "block.minecraft.petrified_oak_slab": "tapaina te papaa",
  "block.minecraft.cobblestone_slab": "parapapa kiripapaku",
  "block.minecraft.brick_slab": "tapahi pereki",
  "block.minecraft.stone_brick_slab": "papara pereki kowhatu",
  "block.minecraft.nether_brick_slab": "nati pereki pereki",
  "block.minecraft.quartz_slab": "tapahi otaota",
  "block.minecraft.red_sandstone_slab": "paraka whero whero",
  "block.minecraft.cut_red_sandstone_slab": "tapahia te tapahi whero whero",
  "block.minecraft.purpur_slab": "papa pūrapūra",
  "block.minecraft.prismarine_slab": "prismarine tapahi",
  "block.minecraft.prismarine_brick_slab": "prismarine pereki pararahe",
  "block.minecraft.dark_prismarine_slab": "poutapeta pouri pouri",
  "block.minecraft.smooth_quartz": "poraka huarahi panui",
  "block.minecraft.smooth_red_sandstone": "he sandenewhero whero",
  "block.minecraft.smooth_sandstone": "hōanga whakaene",
  "block.minecraft.smooth_stone": "he kowhatu whakakata",
  "block.minecraft.bricks": "pereki",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "paenga pukapuka",
  "block.minecraft.mossy_cobblestone": "he koropikoone",
  "block.minecraft.obsidian": "matā",
  "block.minecraft.torch": "rama",
  "block.minecraft.end_rod": "end rod",
  "block.minecraft.chorus_plant": "huinga chorus",
  "block.minecraft.chorus_flower": "puawai chorus",
  "block.minecraft.purpur_block": "poraka waiporoporo",
  "block.minecraft.purpur_pillar": "pou waiporoporo",
  "block.minecraft.purpur_stairs": "arapiki pūrapūra",
  "block.minecraft.spawner": "pūhaka",
  "block.minecraft.oak_stairs": "whare toa",
  "block.minecraft.chest": "pouaka",
  "block.minecraft.diamond_ore": "tokahuke taimana",
  "block.minecraft.diamond_block": "poraka o taimana",
  "block.minecraft.crafting_table": "papamahi",
  "block.minecraft.farmland": "papanga pāmu",
  "block.minecraft.furnace": "oumu",
  "block.minecraft.ladder": "arawhata",
  "block.minecraft.rail": "ara tereina",
  "block.minecraft.cobblestone_stairs": "stone arawhata",
  "block.minecraft.lever": "ara",
  "block.minecraft.stone_pressure_plate": "papatohu panui",
  "block.minecraft.oak_pressure_plate": "taha maatauranga kakano",
  "block.minecraft.spruce_pressure_plate": "whakapaihia te papa perehini",
  "block.minecraft.birch_pressure_plate": "maataha papaahi birch",
  "block.minecraft.jungle_pressure_plate": "nga maatini horoopao",
  "block.minecraft.acacia_pressure_plate": "he papaa acacia pressure",
  "block.minecraft.dark_oak_pressure_plate": "he papaa panui pouri",
  "block.minecraft.crimson_pressure_plate": "pereti taumaha whero",
  "block.minecraft.warped_pressure_plate": "pereti taumaha whawhai",
  "block.minecraft.polished_blackstone_pressure_plate": "plate pato pounamu kua whakakorihia",
  "block.minecraft.redstone_ore": "puka ore",
  "block.minecraft.redstone_torch": "kaihikoi redstone",
  "block.minecraft.snow": "huka",
  "block.minecraft.ice": "haupapa",
  "block.minecraft.snow_block": "hukarere poraka",
  "block.minecraft.cactus": "kakitahi",
  "block.minecraft.clay": "uku",
  "block.minecraft.jukebox": "reo irirangi",
  "block.minecraft.oak_fence": "taiepa",
  "block.minecraft.spruce_fence": "taiapa mataī",
  "block.minecraft.birch_fence": "taiapa petura",
  "block.minecraft.jungle_fence": "taiapa kauri",
  "block.minecraft.acacia_fence": "taiapa keiha",
  "block.minecraft.dark_oak_fence": "taiapa ōki pōuri",
  "block.minecraft.crimson_fence": "harore piimona",
  "block.minecraft.warped_fence": "taiapa pakau",
  "block.minecraft.pumpkin": "paukena",
  "block.minecraft.carved_pumpkin": "paukena whakairo",
  "block.minecraft.netherrack": "whakapau",
  "block.minecraft.soul_sand": "te hone wairua",
  "block.minecraft.soul_soil": "wairua wairua",
  "block.minecraft.basalt": "ōnewa",
  "block.minecraft.polished_basalt": "ōnewa aumiri",
  "block.minecraft.soul_torch": "rama wairua",
  "block.minecraft.glowstone": "papatarere",
  "block.minecraft.jack_o_lantern": "tuhinga o mua",
  "block.minecraft.oak_trapdoor": "raapao puranganui",
  "block.minecraft.spruce_trapdoor": "whakatau rorirori",
  "block.minecraft.birch_trapdoor": "birch trapdoor",
  "block.minecraft.jungle_trapdoor": "whanau huarahi",
  "block.minecraft.acacia_trapdoor": "acacia maapirimapa",
  "block.minecraft.dark_oak_trapdoor": "trapdoor mangapuna",
  "block.minecraft.crimson_trapdoor": "koputaputa whero",
  "block.minecraft.warped_trapdoor": "pakipaki trapeway",
  "block.minecraft.infested_stone": "pōhatu mui",
  "block.minecraft.infested_cobblestone": "pōhatu mui pakaru",
  "block.minecraft.infested_stone_bricks": "pereki pōhatu mui",
  "block.minecraft.infested_mossy_stone_bricks": "pereki pōhatu kurupetipeti mui",
  "block.minecraft.infested_cracked_stone_bricks": "pereki pōhatu mātoetoe mui",
  "block.minecraft.infested_chiseled_stone_bricks": "pereki pōhatu whakairo mui",
  "block.minecraft.stone_bricks": "nga t pohatu kowhatu",
  "block.minecraft.mossy_stone_bricks": "he kowhatu kowhatu kohatu",
  "block.minecraft.cracked_stone_bricks": "nga pereki pohara i werohia",
  "block.minecraft.chiseled_stone_bricks": "he kowhatu pereki kowhatu",
  "block.minecraft.brown_mushroom_block": "paraka paraka whenua",
  "block.minecraft.red_mushroom_block": "poraka tuuturu poraka",
  "block.minecraft.mushroom_stem": "te kakau harakeke",
  "block.minecraft.iron_bars": "taonga toa",
  "block.minecraft.chain": "chain",
  "block.minecraft.glass_pane": "pihanga",
  "block.minecraft.melon": "merengi",
  "block.minecraft.vine": "te karepe",
  "block.minecraft.oak_fence_gate": "putanga ōki",
  "block.minecraft.spruce_fence_gate": "putanga mataī",
  "block.minecraft.birch_fence_gate": "putanga petura",
  "block.minecraft.jungle_fence_gate": "kaha raarangi tere",
  "block.minecraft.acacia_fence_gate": "koko kiriki karai acacia",
  "block.minecraft.dark_oak_fence_gate": "matapihi puka tika pouri",
  "block.minecraft.crimson_fence_gate": "harore piimona",
  "block.minecraft.warped_fence_gate": "te kaha taepa kino",
  "block.minecraft.brick_stairs": "raina pereki",
  "block.minecraft.stone_brick_stairs": "nga pikinga pereki kohatu",
  "block.minecraft.mycelium": "tohu",
  "block.minecraft.lily_pad": "paeroa papa",
  "block.minecraft.nether_bricks": "pereki te reinga",
  "block.minecraft.cracked_nether_bricks": "cracked nether bricks",
  "block.minecraft.chiseled_nether_bricks": "chiseled nether bricks",
  "block.minecraft.nether_brick_fence": "raro taiepa pereki",
  "block.minecraft.nether_brick_stairs": "niiwhiti pirimirua",
  "block.minecraft.enchanting_table": "ripanga whakauru",
  "block.minecraft.end_portal_frame": "anga whakamutu",
  "block.minecraft.end_stone": "mutu kohatu",
  "block.minecraft.end_stone_bricks": "pereki pōhatu pōike",
  "block.minecraft.dragon_egg": "tarakona hua manu",
  "block.minecraft.redstone_lamp": "taamura whero rama",
  "block.minecraft.sandstone_stairs": "hōanga arawhata",
  "block.minecraft.emerald_ore": "emerara kohuke",
  "block.minecraft.ender_chest": "te uma",
  "block.minecraft.tripwire_hook": "nga kaiuru mo nga haerenga",
  "block.minecraft.emerald_block": "emerara poraka",
  "block.minecraft.spruce_stairs": "whakatau papa",
  "block.minecraft.birch_stairs": "pikahe tohu",
  "block.minecraft.jungle_stairs": "whanau ngahere",
  "block.minecraft.crimson_stairs": "pipi piimona",
  "block.minecraft.warped_stairs": "te kaha taepa kino",
  "block.minecraft.command_block": "poraka whakahau",
  "block.minecraft.beacon": "ramaroa",
  "block.minecraft.cobblestone_wall": "paparanga cobblestone",
  "block.minecraft.mossy_cobblestone_wall": "mossy cobblestone wall",
  "block.minecraft.brick_wall": "wharahi pararaihi",
  "block.minecraft.prismarine_wall": "hanga prismarine",
  "block.minecraft.red_sandstone_wall": "te haki mate whero",
  "block.minecraft.mossy_stone_brick_wall": "he kowhatu pereki kohatu",
  "block.minecraft.granite_wall": "matapihi granite",
  "block.minecraft.stone_brick_wall": "matapihi papa pereki",
  "block.minecraft.nether_brick_wall": "horo pereki",
  "block.minecraft.andesite_wall": "whangai panui",
  "block.minecraft.red_nether_brick_wall": "te horoi pereki whero",
  "block.minecraft.sandstone_wall": "taira patu",
  "block.minecraft.end_stone_brick_wall": "whakamutunga pararaini pereki",
  "block.minecraft.diorite_wall": "pakitara diorite",
  "block.minecraft.blackstone_wall": "pa blackstone",
  "block.minecraft.polished_blackstone_wall": "pa pounamu kua oro",
  "block.minecraft.polished_blackstone_brick_wall": "maama pereki pounamu maehe",
  "block.minecraft.stone_button": "pene matariki",
  "block.minecraft.oak_button": "pene matariki",
  "block.minecraft.spruce_button": "whakapaihia te pene",
  "block.minecraft.birch_button": "pātene birch",
  "block.minecraft.jungle_button": "pātene rauuru",
  "block.minecraft.acacia_button": "pene acacia",
  "block.minecraft.dark_oak_button": "pātene oak pouri",
  "block.minecraft.crimson_button": "pihi whero",
  "block.minecraft.warped_button": "pihi peke",
  "block.minecraft.polished_blackstone_button": "polished blackstone button",
  "block.minecraft.anvil": "paepae maitai",
  "block.minecraft.chipped_anvil": "hipoki heru",
  "block.minecraft.damaged_anvil": "ngaro kino heru",
  "block.minecraft.trapped_chest": "aaka mau",
  "block.minecraft.light_weighted_pressure_plate": "he maama whakanoho taha maama",
  "block.minecraft.heavy_weighted_pressure_plate": "he maataha paha whananga taumaha",
  "block.minecraft.daylight_detector": "kaititiro awatea",
  "block.minecraft.redstone_block": "poraka te puehu whero",
  "block.minecraft.nether_quartz_ore": "nether quartz ore",
  "block.minecraft.hopper": "kōrere",
  "block.minecraft.chiseled_quartz_block": "poraka pouaka quis",
  "block.minecraft.quartz_block": "paraka takawai",
  "block.minecraft.quartz_bricks": "quartz bricks",
  "block.minecraft.quartz_pillar": "pou kiripaka",
  "block.minecraft.quartz_stairs": "nga arawhata quartz",
  "block.minecraft.activator_rail": "activator rail",
  "block.minecraft.dropper": "pūporo",
  "block.minecraft.white_terracotta": "terakota tea",
  "block.minecraft.orange_terracotta": "terakota karaka",
  "block.minecraft.magenta_terracotta": "terakota mākurakura",
  "block.minecraft.light_blue_terracotta": "terakota ōrangitea",
  "block.minecraft.yellow_terracotta": "terakota kōwhai",
  "block.minecraft.lime_terracotta": "terakota kārikikōwhai",
  "block.minecraft.pink_terracotta": "terakota māwhero",
  "block.minecraft.gray_terracotta": "terakota kiwikiwi",
  "block.minecraft.light_gray_terracotta": "terakota kiwitea",
  "block.minecraft.cyan_terracotta": "terakota kārikiōrangi",
  "block.minecraft.purple_terracotta": "terakota pāpura",
  "block.minecraft.blue_terracotta": "terakota kikorangi",
  "block.minecraft.brown_terracotta": "terakota parauri",
  "block.minecraft.green_terracotta": "terakota kākāriki",
  "block.minecraft.red_terracotta": "terakota whero",
  "block.minecraft.black_terracotta": "terakota pango",
  "block.minecraft.barrier": "te kaipara",
  "block.minecraft.iron_trapdoor": "te matapihi tino",
  "block.minecraft.hay_block": "hay wuru",
  "block.minecraft.white_carpet": "karepa white",
  "block.minecraft.orange_carpet": "te whāriki karaka",
  "block.minecraft.magenta_carpet": "whāriki peita",
  "block.minecraft.light_blue_carpet": "whāriki ōrangitea",
  "block.minecraft.yellow_carpet": "te whāriki kowhai",
  "block.minecraft.lime_carpet": "karepa white",
  "block.minecraft.pink_carpet": "whāriki māwhero",
  "block.minecraft.gray_carpet": "whāriki kiwikiwi",
  "block.minecraft.light_gray_carpet": "whāriki kiwitea",
  "block.minecraft.cyan_carpet": "whāriki kārikiōrangi",
  "block.minecraft.purple_carpet": "whāriki pāpura",
  "block.minecraft.blue_carpet": "whāriki kikorangi",
  "block.minecraft.brown_carpet": "whāriki parauri",
  "block.minecraft.green_carpet": "whāriki kākāriki",
  "block.minecraft.red_carpet": "whāriki whero",
  "block.minecraft.black_carpet": "whāriki pango",
  "block.minecraft.terracotta": "terakota",
  "block.minecraft.coal_block": "poraka o coal",
  "block.minecraft.packed_ice": "tio mātotoru",
  "block.minecraft.acacia_stairs": "papaea acacia",
  "block.minecraft.dark_oak_stairs": "pika ngai tu pouri",
  "block.minecraft.slime_block": "poraka huti",
  "block.minecraft.grass_path": "ara karaihe",
  "block.minecraft.sunflower": "putiputi rā",
  "block.minecraft.lilac": "whakatika",
  "block.minecraft.rose_bush": "rōha",
  "block.minecraft.peony": "peita",
  "block.minecraft.tall_grass": "tarutaru otaota",
  "block.minecraft.large_fern": "ponga",
  "block.minecraft.white_stained_glass": "karaihe karaka white",
  "block.minecraft.orange_stained_glass": "karaihe karaka orange",
  "block.minecraft.magenta_stained_glass": "he karaehe karaihe magenta",
  "block.minecraft.light_blue_stained_glass": "he karaka kikorangi kikorangi",
  "block.minecraft.yellow_stained_glass": "karaihe karaka kowhai",
  "block.minecraft.lime_stained_glass": "he karaihe maramara",
  "block.minecraft.pink_stained_glass": "pink ōpure koata",
  "block.minecraft.gray_stained_glass": "gray ōpure koata",
  "block.minecraft.light_gray_stained_glass": "light gray ōpure koata",
  "block.minecraft.cyan_stained_glass": "urikiko ōpure koata",
  "block.minecraft.purple_stained_glass": "papura ōpure koata",
  "block.minecraft.blue_stained_glass": "blue ōpure koata",
  "block.minecraft.brown_stained_glass": "brown ōpure koata",
  "block.minecraft.green_stained_glass": "green ōpure koata",
  "block.minecraft.red_stained_glass": "whero ōpure koata",
  "block.minecraft.black_stained_glass": "black ōpure koata",
  "block.minecraft.white_stained_glass_pane": "pane karaehe kara",
  "block.minecraft.orange_stained_glass_pane": "pane karaehe karaihe karaka",
  "block.minecraft.magenta_stained_glass_pane": "pawhaea peane karawhiu",
  "block.minecraft.light_blue_stained_glass_pane": "pane puru pane karaehe pane",
  "block.minecraft.yellow_stained_glass_pane": "pane karaehe karaehe kowhai",
  "block.minecraft.lime_stained_glass_pane": "he kotakota karaehe pane",
  "block.minecraft.pink_stained_glass_pane": "pane whero karaehe pane",
  "block.minecraft.gray_stained_glass_pane": "pane kākāriki pane",
  "block.minecraft.light_gray_stained_glass_pane": "pane kākāriki karaehe pane",
  "block.minecraft.cyan_stained_glass_pane": "cyan pane karaihe pane",
  "block.minecraft.purple_stained_glass_pane": "ko te pane karaehe pane",
  "block.minecraft.blue_stained_glass_pane": "pane karaehe karaehe pane",
  "block.minecraft.brown_stained_glass_pane": "pane karaehe karaehe parauri",
  "block.minecraft.green_stained_glass_pane": "pane kākāriki pane",
  "block.minecraft.red_stained_glass_pane": "whero pane kākahu whero",
  "block.minecraft.black_stained_glass_pane": "pane karaehe karaehe pango",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_bricks": "prismarine bricks",
  "block.minecraft.dark_prismarine": "dark prismarine",
  "block.minecraft.prismarine_stairs": "tūturu prismarine",
  "block.minecraft.prismarine_brick_stairs": "prismarine piira patu",
  "block.minecraft.dark_prismarine_stairs": "tūruuru prismarine pouri",
  "block.minecraft.sea_lantern": "rama moana",
  "block.minecraft.red_sandstone": "te tunaeke whero",
  "block.minecraft.chiseled_red_sandstone": "he sandenewhero whero",
  "block.minecraft.cut_red_sandstone": "tapahia te sandstone whero",
  "block.minecraft.red_sandstone_stairs": "whero taimana whero",
  "block.minecraft.repeating_command_block": "whakahoki poutohu poraka",
  "block.minecraft.chain_command_block": "poraka whakahau",
  "block.minecraft.magma_block": "paraka tokawera",
  "block.minecraft.nether_wart_block": "paraka tona rarohenga",
  "block.minecraft.warped_wart_block": "warping wart poraka",
  "block.minecraft.red_nether_bricks": "pereki rarohenga whero",
  "block.minecraft.bone_block": "paraka kōiwi",
  "block.minecraft.structure_void": "structure void",
  "block.minecraft.observer": "kaimātakitaki",
  "block.minecraft.shulker_box": "pouaka huruka",
  "block.minecraft.white_shulker_box": "pouaka huruka tea",
  "block.minecraft.orange_shulker_box": "pouaka huruka karaka",
  "block.minecraft.magenta_shulker_box": "pouaka huruka mākurakura",
  "block.minecraft.light_blue_shulker_box": "pouaka huruka ōrangitea",
  "block.minecraft.yellow_shulker_box": "pouaka huruka kōwhai",
  "block.minecraft.lime_shulker_box": "pouaka huruka kārikikōwhai",
  "block.minecraft.pink_shulker_box": "pouaka huruka māwhero",
  "block.minecraft.gray_shulker_box": "pouaka huruka kiwikiwi",
  "block.minecraft.light_gray_shulker_box": "pouaka huruka kiwitea",
  "block.minecraft.cyan_shulker_box": "pouaka huruka kārikiōrangi",
  "block.minecraft.purple_shulker_box": "pouaka huruka pāpura",
  "block.minecraft.blue_shulker_box": "pouaka huruka kikorangi",
  "block.minecraft.brown_shulker_box": "pouaka huruka parauri",
  "block.minecraft.green_shulker_box": "pouaka huruka kākāriki",
  "block.minecraft.red_shulker_box": "pouaka huruka whero",
  "block.minecraft.black_shulker_box": "pouaka huruka pango",
  "block.minecraft.white_glazed_terracotta": "terakota kirimōhinu tea",
  "block.minecraft.orange_glazed_terracotta": "terakota kirimōhinu karaka",
  "block.minecraft.magenta_glazed_terracotta": "terakota kirimōhinu mākurakura",
  "block.minecraft.light_blue_glazed_terracotta": "terakota kirimōhinu ōrangitea",
  "block.minecraft.yellow_glazed_terracotta": "terakota kirimōhinu kōwhai",
  "block.minecraft.lime_glazed_terracotta": "terakota kirimōhinu kārikikōwhai",
  "block.minecraft.pink_glazed_terracotta": "terakota kirimōhinu māwhero",
  "block.minecraft.gray_glazed_terracotta": "terakota kirimōhinu kiwikiwi",
  "block.minecraft.light_gray_glazed_terracotta": "terakota kirimōhinu kiwitea",
  "block.minecraft.cyan_glazed_terracotta": "terakota kirimōhinu kārikiōrangi",
  "block.minecraft.purple_glazed_terracotta": "terakota kirimōhinu pāpura",
  "block.minecraft.blue_glazed_terracotta": "terakota kirimōhinu kikorangi",
  "block.minecraft.brown_glazed_terracotta": "terakota kirimōhinu parauri",
  "block.minecraft.green_glazed_terracotta": "terakota kirimōhinu kākāriki",
  "block.minecraft.red_glazed_terracotta": "terakota kirimōhinu whero",
  "block.minecraft.black_glazed_terracotta": "terakota kirimōhinu pango",
  "block.minecraft.white_concrete": "raima ma",
  "block.minecraft.orange_concrete": "raima orange",
  "block.minecraft.magenta_concrete": "magenta raima",
  "block.minecraft.light_blue_concrete": "raima kahurangi maama",
  "block.minecraft.yellow_concrete": "raima kowhai",
  "block.minecraft.lime_concrete": "raima raima",
  "block.minecraft.pink_concrete": "raima mawhero",
  "block.minecraft.gray_concrete": "raima uira",
  "block.minecraft.light_gray_concrete": "raima kerei uira",
  "block.minecraft.cyan_concrete": "raima kārikiōrangi",
  "block.minecraft.purple_concrete": "raima pāpura",
  "block.minecraft.blue_concrete": "raima kikorangi",
  "block.minecraft.brown_concrete": "raima parauri",
  "block.minecraft.green_concrete": "raima kākāriki",
  "block.minecraft.red_concrete": "raima whero",
  "block.minecraft.black_concrete": "raima pango",
  "block.minecraft.white_concrete_powder": "paura raima ma",
  "block.minecraft.orange_concrete_powder": "paura raima karaka",
  "block.minecraft.magenta_concrete_powder": "paura raima magenta",
  "block.minecraft.light_blue_concrete_powder": "paura raima raima maama",
  "block.minecraft.yellow_concrete_powder": "paura raima kowhai",
  "block.minecraft.lime_concrete_powder": "paura raima raima",
  "block.minecraft.pink_concrete_powder": "paura raima mawhero",
  "block.minecraft.gray_concrete_powder": "paura raima kerei",
  "block.minecraft.light_gray_concrete_powder": "paura raima koura maama",
  "block.minecraft.cyan_concrete_powder": "paura raima cyan",
  "block.minecraft.purple_concrete_powder": "paura raima waiporoporo",
  "block.minecraft.blue_concrete_powder": "paura raima kikorangi",
  "block.minecraft.brown_concrete_powder": "paura raima parauri",
  "block.minecraft.green_concrete_powder": "paura raima kakariki",
  "block.minecraft.red_concrete_powder": "paura raima whero",
  "block.minecraft.black_concrete_powder": "paura raima pango",
  "block.minecraft.turtle_egg": "hēki honu",
  "block.minecraft.dead_tube_coral_block": "dead tube coral block",
  "block.minecraft.dead_brain_coral_block": "dead brain coral block",
  "block.minecraft.dead_bubble_coral_block": "dead bubble coral block",
  "block.minecraft.dead_fire_coral_block": "dead fire coral block",
  "block.minecraft.dead_horn_coral_block": "poraka horn mate poraka",
  "block.minecraft.tube_coral_block": "tube coral poraka",
  "block.minecraft.brain_coral_block": "poraka coral brain",
  "block.minecraft.bubble_coral_block": "bubble coral block",
  "block.minecraft.fire_coral_block": "poraka coral ahi",
  "block.minecraft.horn_coral_block": "horn coral block",
  "block.minecraft.tube_coral": "coral tube",
  "block.minecraft.brain_coral": "coral brain",
  "block.minecraft.bubble_coral": "coral bubble",
  "block.minecraft.fire_coral": "coral ahi",
  "block.minecraft.horn_coral": "coral horn",
  "block.minecraft.dead_brain_coral": "coral brain mate",
  "block.minecraft.dead_bubble_coral": "coral bubble mate",
  "block.minecraft.dead_fire_coral": "coral ahi mate",
  "block.minecraft.dead_horn_coral": "coral horn mate",
  "block.minecraft.dead_tube_coral": "coral tube mate",
  "block.minecraft.tube_coral_fan": "fan coral tube",
  "block.minecraft.brain_coral_fan": "taonga coral brain",
  "block.minecraft.bubble_coral_fan": "fan fan coral bubble",
  "block.minecraft.fire_coral_fan": "fan coral fire",
  "block.minecraft.horn_coral_fan": "fan fan coral",
  "block.minecraft.dead_tube_coral_fan": "mate ngaro koura coral",
  "block.minecraft.dead_brain_coral_fan": "peera coral brain mate",
  "block.minecraft.dead_bubble_coral_fan": "peera coral bubble mate",
  "block.minecraft.dead_fire_coral_fan": "fan fan coral mate",
  "block.minecraft.dead_horn_coral_fan": "peera koura horn mate",
  "block.minecraft.blue_ice": "tio kikōrangi",
  "block.minecraft.conduit": "arataki",
  "block.minecraft.polished_granite_stairs": "tūru granite",
  "block.minecraft.smooth_red_sandstone_stairs": "he tohu peariki whero",
  "block.minecraft.mossy_stone_brick_stairs": "te hika mihinikini tohu",
  "block.minecraft.polished_diorite_stairs": "pika diorite pai",
  "block.minecraft.mossy_cobblestone_stairs": "te noho tuurakau",
  "block.minecraft.end_stone_brick_stairs": "whakamutu i nga taimana pereki kohatu",
  "block.minecraft.stone_stairs": "tūpāpaku papa",
  "block.minecraft.smooth_sandstone_stairs": "tūtohu māhorahora",
  "block.minecraft.smooth_quartz_stairs": "tūru tuarua maeneene",
  "block.minecraft.granite_stairs": "nenuka granite",
  "block.minecraft.andesite_stairs": "taumata andesite",
  "block.minecraft.red_nether_brick_stairs": "whero pereki pararau whero",
  "block.minecraft.polished_andesite_stairs": "tūru andesite pai",
  "block.minecraft.diorite_stairs": "whare pouturu",
  "block.minecraft.polished_granite_slab": "tapahi maihi granite",
  "block.minecraft.smooth_red_sandstone_slab": "whakapirihia te whero whero sandst slab",
  "block.minecraft.mossy_stone_brick_slab": "moohiini pereki kohatu",
  "block.minecraft.polished_diorite_slab": "tapahi diorite pai",
  "block.minecraft.mossy_cobblestone_slab": "hupirimi koropiko parapata",
  "block.minecraft.end_stone_brick_slab": "whakamutua te kowhatu perehana kowhatu",
  "block.minecraft.smooth_sandstone_slab": "taputapu kiripaka maeneene",
  "block.minecraft.smooth_quartz_slab": "paraka tuarua maeneene",
  "block.minecraft.granite_slab": "tapahi granite",
  "block.minecraft.andesite_slab": "tapahi andesite",
  "block.minecraft.red_nether_brick_slab": "whero whero pereki parapata",
  "block.minecraft.polished_andesite_slab": "tapahi andesite tapahi",
  "block.minecraft.diorite_slab": "tapahi diorite",
  "block.minecraft.scaffolding": "whakauru",
  "block.minecraft.iron_door": "tatau rino",
  "block.minecraft.oak_door": "tatau oke",
  "block.minecraft.spruce_door": "whakatau door",
  "block.minecraft.birch_door": "pahau puka",
  "block.minecraft.jungle_door": "jungle door",
  "block.minecraft.acacia_door": "pouaka acacia",
  "block.minecraft.dark_oak_door": "pouaka pouri",
  "block.minecraft.crimson_door": "kuwhera whero",
  "block.minecraft.warped_door": "kowaha kuwha",
  "block.minecraft.repeater": "redstone repeater",
  "block.minecraft.comparator": "redstone comparator",
  "block.minecraft.structure_block": "structure block",
  "block.minecraft.jigsaw": "jigsaw poraka",
  "item.minecraft.turtle_helmet": "pōtae honu□□a, no te upoko:□+2 whawhai",
  "item.minecraft.scute": "scute",
  "item.minecraft.iron_shovel": "koko rino□□i te ringa matua:□+3.5 tukino whakaeke□-3 tere whakaeke",
  "item.minecraft.iron_pickaxe": "pika rino□□i te ringa matua:□+3 tukino whakaeke□-2.8 tere whakaeke",
  "item.minecraft.iron_axe": "toki rino□□i te ringa matua:□+8 tukino whakaeke□-3.1 tere whakaeke",
  "item.minecraft.flint_and_steel": "matā me tīra",
  "item.minecraft.apple": "āporo",
  "item.minecraft.bow": "kopere",
  "item.minecraft.arrow": "pere",
  "item.minecraft.coal": "waro",
  "item.minecraft.charcoal": "waro",
  "item.minecraft.diamond": "taimana",
  "item.minecraft.iron_ingot": "rino",
  "item.minecraft.gold_ingot": "kōura",
  "item.minecraft.netherite_ingot": "tawhito ingore",
  "item.minecraft.netherite_scrap": "netherite scrap",
  "item.minecraft.iron_sword": "hoari rino□□i te ringa matua:□+5 tukino whakaeke□-2.4 tere whakaeke",
  "item.minecraft.wooden_sword": "hoari rākau□□i te ringa matua:□+3 tukino whakaeke□-2.4 tere whakaeke",
  "item.minecraft.wooden_shovel": "koko rākau□□i te ringa matua:□+1.5 tukino whakaeke□-3 tere whakaeke",
  "item.minecraft.wooden_pickaxe": "pika rākau□□i te ringa matua:□+1 tukino whakaeke□-2.8 tere whakaeke",
  "item.minecraft.wooden_axe": "toki rākau□□i te ringa matua:□+6 tukino whakaeke□-3.2 tere whakaeke",
  "item.minecraft.stone_sword": "hoari kōhatu□□i te ringa matua:□+4 tukino whakaeke□-2.4 tere whakaeke",
  "item.minecraft.stone_shovel": "koko kōhatu□□i te ringa matua:□+2.5 tukino whakaeke□-3 tere whakaeke",
  "item.minecraft.stone_pickaxe": "pika kōhatu□□i te ringa matua:□+2 tukino whakaeke□-2.8 tere whakaeke",
  "item.minecraft.stone_axe": "toki kōhatu□□i te ringa matua:□+8 tukino whakaeke□-3.2 tere whakaeke",
  "item.minecraft.diamond_sword": "hoari taimana□□i te ringa matua:□+6 tukino whakaeke□-2.4 tere whakaeke",
  "item.minecraft.diamond_shovel": "koko taimana□□i te ringa matua:□+4.5 tukino whakaeke□-3 tere whakaeke",
  "item.minecraft.diamond_pickaxe": "pika taimana□□i te ringa matua:□+4 tukino whakaeke□-2.8 tere whakaeke",
  "item.minecraft.diamond_axe": "toki taimana□□i te ringa matua:□+8 tukino whakaeke□-3 tere whakaeke",
  "item.minecraft.stick": "rākau",
  "item.minecraft.bowl": "bowl",
  "item.minecraft.mushroom_stew": "mushroom stew",
  "item.minecraft.golden_sword": "hoari kōura□□i te ringa matua:□+3 tukino whakaeke□-2.4 tere whakaeke",
  "item.minecraft.golden_shovel": "koko kōura□□i te ringa matua:□+1.5 tukino whakaeke□-3 tere whakaeke",
  "item.minecraft.golden_pickaxe": "pika kōura□□i te ringa matua:□+1 tukino whakaeke□-2.8 tere whakaeke",
  "item.minecraft.golden_axe": "toki kōura□□i te ringa matua:□+6 tukino whakaeke□-3 tere whakaeke",
  "item.minecraft.netherite_sword": "netherite sword□□i te ringa matua:□+7 tukino whakaeke□-2.4 tere whakaeke",
  "item.minecraft.netherite_shovel": "netherite shovel□□i te ringa matua:□+5.5 tukino whakaeke□-3 tere whakaeke",
  "item.minecraft.netherite_pickaxe": "netherite pikakeke□□i te ringa matua:□+5 tukino whakaeke□-2.8 tere whakaeke",
  "item.minecraft.netherite_axe": "tawhito pātītī□□i te ringa matua:□+9 tukino whakaeke□-3 tere whakaeke",
  "item.minecraft.string": "aho",
  "item.minecraft.feather": "piki",
  "item.minecraft.gunpowder": "paura",
  "item.minecraft.wooden_hoe": "hetiheti rākau□□i te ringa matua:□-3 tere whakaeke",
  "item.minecraft.stone_hoe": "hetiheti kōhatu□□i te ringa matua:□-2 tere whakaeke",
  "item.minecraft.iron_hoe": "hetiheti rino□□i te ringa matua:□-1 tere whakaeke",
  "item.minecraft.diamond_hoe": "hetiheti taimana□□i te ringa matua:",
  "item.minecraft.golden_hoe": "hetiheti kōura□□i te ringa matua:□-3 tere whakaeke",
  "item.minecraft.netherite_hoe": "netherite hoe□□i te ringa matua:",
  "item.minecraft.wheat_seeds": "kākano witi",
  "item.minecraft.wheat": "wīti",
  "item.minecraft.bread": "parāoa",
  "item.minecraft.leather_helmet": "pōtae kirikau□□a, no te upoko:□+1 whawhai",
  "item.minecraft.leather_chestplate": "kahu ārai kirikau□□ana kei te tinana:□+3 whawhai",
  "item.minecraft.leather_leggings": "tarau kirikau□□ka paa ana ki nga waewae:□+2 whawhai",
  "item.minecraft.leather_boots": "pūtu kirikau□□a, no te i runga i nga waewae:□+1 whawhai",
  "item.minecraft.chainmail_helmet": "pōtae mekameka□□a, no te upoko:□+2 whawhai",
  "item.minecraft.chainmail_chestplate": "kahu ārai mekameka□□ana kei te tinana:□+5 whawhai",
  "item.minecraft.chainmail_leggings": "tarau mekameka□□ka paa ana ki nga waewae:□+4 whawhai",
  "item.minecraft.chainmail_boots": "pūtu mekameka□□a, no te i runga i nga waewae:□+1 whawhai",
  "item.minecraft.iron_helmet": "pōtae rino□□a, no te upoko:□+2 whawhai",
  "item.minecraft.iron_chestplate": "kahu ārai rino□□ana kei te tinana:□+6 whawhai",
  "item.minecraft.iron_leggings": "tarau rino□□ka paa ana ki nga waewae:□+5 whawhai",
  "item.minecraft.iron_boots": "pūtu rino□□a, no te i runga i nga waewae:□+2 whawhai",
  "item.minecraft.diamond_helmet": "pōtae taimana□□a, no te upoko:□+3 whawhai□+2 te kaha haana",
  "item.minecraft.diamond_chestplate": "kahu ārai taimana□□ana kei te tinana:□+8 whawhai□+2 te kaha haana",
  "item.minecraft.diamond_leggings": "tarau taimana□□ka paa ana ki nga waewae:□+6 whawhai□+2 te kaha haana",
  "item.minecraft.diamond_boots": "pūtu taimana□□a, no te i runga i nga waewae:□+3 whawhai□+2 te kaha haana",
  "item.minecraft.golden_helmet": "pōtae kōura□□a, no te upoko:□+2 whawhai",
  "item.minecraft.golden_chestplate": "kahu ārai kōura□□ana kei te tinana:□+5 whawhai",
  "item.minecraft.golden_leggings": "tarau kōura□□ka paa ana ki nga waewae:□+3 whawhai",
  "item.minecraft.golden_boots": "pūtu kōura□□a, no te i runga i nga waewae:□+1 whawhai",
  "item.minecraft.netherite_helmet": "tawhito potae□□a, no te upoko:□+3 whawhai□+3 te kaha haana□+1 te atete whakamuri",
  "item.minecraft.netherite_chestplate": "tawhito pukupuku□□ana kei te tinana:□+8 whawhai□+3 te kaha haana□+1 te atete whakamuri",
  "item.minecraft.netherite_leggings": "tawhito raupapatanga□□ka paa ana ki nga waewae:□+6 whawhai□+3 te kaha haana□+1 te atete whakamuri",
  "item.minecraft.netherite_boots": "tawhito taika□□a, no te i runga i nga waewae:□+3 whawhai□+3 te kaha haana□+1 te atete whakamuri",
  "item.minecraft.flint": "matā",
  "item.minecraft.porkchop": "raw porkchop",
  "item.minecraft.cooked_porkchop": "cooked porkchop",
  "item.minecraft.painting": "waituhi",
  "item.minecraft.golden_apple": "āporo kōura",
  "item.minecraft.enchanted_golden_apple": "enchanted golden apple",
  "block.minecraft.oak_sign": "waitohu raaka",
  "block.minecraft.spruce_sign": "tohu whakaaetanga",
  "block.minecraft.birch_sign": "waitohu birch",
  "block.minecraft.jungle_sign": "waitohu huna",
  "block.minecraft.acacia_sign": "kehia hainatanga",
  "block.minecraft.dark_oak_sign": "whēuriuri ōki hainatanga",
  "block.minecraft.crimson_sign": "waitohu whero",
  "block.minecraft.warped_sign": "tohu korero",
  "item.minecraft.bucket": "pēre",
  "item.minecraft.water_bucket": "pēre wai",
  "item.minecraft.lava_bucket": "pēre tahepuia",
  "item.minecraft.minecart": "minecart",
  "item.minecraft.saddle": "tera",
  "item.minecraft.redstone": "redstone puehu",
  "item.minecraft.snowball": "poi huka",
  "item.minecraft.oak_boat": "oak boat",
  "item.minecraft.leather": "rera",
  "item.minecraft.milk_bucket": "pēre miraka",
  "item.minecraft.pufferfish_bucket": "bucket of pufferfish",
  "item.minecraft.salmon_bucket": "bucket of salmon",
  "item.minecraft.cod_bucket": "bucket of cod",
  "item.minecraft.tropical_fish_bucket": "bucket of tropical fish",
  "item.minecraft.brick": "brick",
  "item.minecraft.clay_ball": "pōrakaraka",
  "block.minecraft.dried_kelp_block": "kakau kelp poraka",
  "item.minecraft.paper": "pepa",
  "item.minecraft.book": "pukapuka",
  "item.minecraft.slime_ball": "slimeball",
  "item.minecraft.chest_minecart": "minecart with chest",
  "item.minecraft.furnace_minecart": "minecart with furnace",
  "item.minecraft.egg": "hēki",
  "item.minecraft.compass": "kāpehu",
  "item.minecraft.fishing_rod": "matira",
  "item.minecraft.clock": "karaka",
  "item.minecraft.glowstone_dust": "glowstone dust",
  "item.minecraft.cod": "raw cod",
  "item.minecraft.salmon": "raw salmon",
  "item.minecraft.tropical_fish": "tropical fish",
  "item.minecraft.pufferfish": "pufferfish",
  "item.minecraft.cooked_cod": "cooked cod",
  "item.minecraft.cooked_salmon": "cooked salmon",
  "item.minecraft.ink_sac": "ink sac",
  "item.minecraft.red_dye": "horoi whero",
  "item.minecraft.green_dye": "puawai green",
  "item.minecraft.cocoa_beans": "cocoa beans",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "purple dye",
  "item.minecraft.cyan_dye": "cyan dye",
  "item.minecraft.light_gray_dye": "light gray dye",
  "item.minecraft.gray_dye": "gray dye",
  "item.minecraft.pink_dye": "pink dye",
  "item.minecraft.lime_dye": "lime dye",
  "item.minecraft.yellow_dye": "puawai kowhai",
  "item.minecraft.light_blue_dye": "light blue dye",
  "item.minecraft.magenta_dye": "magenta dye",
  "item.minecraft.orange_dye": "orange dye",
  "item.minecraft.bone_meal": "bone meal",
  "item.minecraft.blue_dye": "puarua blue",
  "item.minecraft.brown_dye": "whakapukapuka parauri",
  "item.minecraft.black_dye": "korehu putu",
  "item.minecraft.white_dye": "waikano white",
  "item.minecraft.bone": "wheua",
  "item.minecraft.sugar": "sugar",
  "block.minecraft.cake": "keke",
  "block.minecraft.white_bed": "white bed",
  "block.minecraft.orange_bed": "orange bed",
  "block.minecraft.magenta_bed": "magenta bed",
  "block.minecraft.light_blue_bed": "light blue bed",
  "block.minecraft.yellow_bed": "yellow bed",
  "block.minecraft.lime_bed": "lime bed",
  "block.minecraft.pink_bed": "pink bed",
  "block.minecraft.gray_bed": "gray bed",
  "block.minecraft.light_gray_bed": "light gray bed",
  "block.minecraft.cyan_bed": "cyan bed",
  "block.minecraft.purple_bed": "purple bed",
  "block.minecraft.blue_bed": "blue bed",
  "block.minecraft.brown_bed": "brown bed",
  "block.minecraft.green_bed": "green bed",
  "block.minecraft.red_bed": "red bed",
  "block.minecraft.black_bed": "black bed",
  "item.minecraft.cookie": "pihikete",
  "item.minecraft.filled_map": "mapi□#0",
  "item.minecraft.shears": "shears",
  "item.minecraft.melon_slice": "melon slice",
  "item.minecraft.dried_kelp": "dried kelp",
  "item.minecraft.pumpkin_seeds": "kākano paukena",
  "item.minecraft.melon_seeds": "kākano mereni",
  "item.minecraft.beef": "raw beef",
  "item.minecraft.cooked_beef": "kotinga mīti",
  "item.minecraft.chicken": "raw chicken",
  "item.minecraft.cooked_chicken": "cooked chicken",
  "item.minecraft.rotten_flesh": "rotten flesh",
  "item.minecraft.ender_pearl": "ender pearl",
  "item.minecraft.blaze_rod": "blaze rod",
  "item.minecraft.ghast_tear": "ghast tear",
  "item.minecraft.gold_nugget": "gold nugget",
  "item.minecraft.nether_wart": "nether wart",
  "item.minecraft.potion": "uncraftable potion□nga hua fov",
  "item.minecraft.glass_bottle": "pātara karaehe",
  "item.minecraft.spider_eye": "spider eye",
  "item.minecraft.fermented_spider_eye": "fermented spider eye",
  "item.minecraft.blaze_powder": "blaze powder",
  "item.minecraft.magma_cream": "magma cream",
  "block.minecraft.brewing_stand": "tu whakatikatika",
  "block.minecraft.cauldron": "karaka",
  "item.minecraft.ender_eye": "eye of ender",
  "item.minecraft.glistering_melon_slice": "glistering melon slice",
  "item.minecraft.bat_spawn_egg": "bat spawn egg",
  "item.minecraft.bee_spawn_egg": "ko te hua o te karanga o te pi",
  "item.minecraft.blaze_spawn_egg": "blaze spawn egg",
  "item.minecraft.cat_spawn_egg": "cat pata korero",
  "item.minecraft.cave_spider_spawn_egg": "cave spider spawn egg",
  "item.minecraft.chicken_spawn_egg": "chicken spawn egg",
  "item.minecraft.cod_spawn_egg": "cod spawn egg",
  "item.minecraft.cow_spawn_egg": "cow spawn egg",
  "item.minecraft.creeper_spawn_egg": "creeper spawn egg",
  "item.minecraft.dolphin_spawn_egg": "dolphin spawn egg",
  "item.minecraft.donkey_spawn_egg": "donkey spawn egg",
  "item.minecraft.drowned_spawn_egg": "drowned spawn egg",
  "item.minecraft.elder_guardian_spawn_egg": "elder guardian spawn egg",
  "item.minecraft.enderman_spawn_egg": "enderman spawn egg",
  "item.minecraft.endermite_spawn_egg": "endermite spawn egg",
  "item.minecraft.evoker_spawn_egg": "evoker spawn egg",
  "item.minecraft.fox_spawn_egg": "fox tono korero",
  "item.minecraft.ghast_spawn_egg": "ghast spawn egg",
  "item.minecraft.guardian_spawn_egg": "guardian spawn egg",
  "item.minecraft.hoglin_spawn_egg": "hoglin spawn egg",
  "item.minecraft.horse_spawn_egg": "horse spawn egg",
  "item.minecraft.husk_spawn_egg": "husk spawn egg",
  "item.minecraft.llama_spawn_egg": "llama spawn egg",
  "item.minecraft.magma_cube_spawn_egg": "magma cube spawn egg",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom spawn egg",
  "item.minecraft.mule_spawn_egg": "mule spawn egg",
  "item.minecraft.ocelot_spawn_egg": "ocelot spawn egg",
  "item.minecraft.panda_spawn_egg": "pānata tohu kōrero",
  "item.minecraft.parrot_spawn_egg": "parrot spawn egg",
  "item.minecraft.phantom_spawn_egg": "phantom spawn egg",
  "item.minecraft.pig_spawn_egg": "pig spawn egg",
  "item.minecraft.piglin_spawn_egg": "piglin tohu korero",
  "item.minecraft.pillager_spawn_egg": "te papara tiki korero",
  "item.minecraft.polar_bear_spawn_egg": "pea poara tiki kōrero",
  "item.minecraft.pufferfish_spawn_egg": "pufferfish spawn egg",
  "item.minecraft.rabbit_spawn_egg": "rabbit spawn egg",
  "item.minecraft.ravager_spawn_egg": "te atawhai tiki korero",
  "item.minecraft.salmon_spawn_egg": "salmon spawn egg",
  "item.minecraft.sheep_spawn_egg": "sheep spawn egg",
  "item.minecraft.shulker_spawn_egg": "shulker spawn egg",
  "item.minecraft.silverfish_spawn_egg": "silverfish spawn egg",
  "item.minecraft.skeleton_spawn_egg": "skeleton spawn egg",
  "item.minecraft.skeleton_horse_spawn_egg": "skeleton horse spawn egg",
  "item.minecraft.slime_spawn_egg": "slime spawn egg",
  "item.minecraft.spider_spawn_egg": "spider spawn egg",
  "item.minecraft.squid_spawn_egg": "squid spawn egg",
  "item.minecraft.stray_spawn_egg": "stray spawn egg",
  "item.minecraft.strider_spawn_egg": "strider spawn egg",
  "item.minecraft.trader_llama_spawn_egg": "he hoko tuarua trader llama",
  "item.minecraft.tropical_fish_spawn_egg": "tropical fish spawn egg",
  "item.minecraft.turtle_spawn_egg": "turtle spawn egg",
  "item.minecraft.vex_spawn_egg": "vex spawn egg",
  "item.minecraft.villager_spawn_egg": "villager spawn egg",
  "item.minecraft.vindicator_spawn_egg": "vindicator spawn egg",
  "item.minecraft.wandering_trader_spawn_egg": "wandering trader egg",
  "item.minecraft.witch_spawn_egg": "witch spawn egg",
  "item.minecraft.wither_skeleton_spawn_egg": "wither skeleton spawn egg",
  "item.minecraft.wolf_spawn_egg": "wolf spawn egg",
  "item.minecraft.zoglin_spawn_egg": "zoglin spawn egg",
  "item.minecraft.zombie_spawn_egg": "zombie spawn egg",
  "item.minecraft.zombie_horse_spawn_egg": "zombie horse spawn egg",
  "item.minecraft.zombie_villager_spawn_egg": "zombie villager spawn egg",
  "item.minecraft.zombified_piglin_spawn_egg": "whakatakotoria tiki tuturu ki a piglin",
  "item.minecraft.experience_bottle": "bottle o' enchanting",
  "item.minecraft.fire_charge": "fire charge",
  "item.minecraft.writable_book": "pukapuka me te tuaka",
  "item.minecraft.written_book": "written book",
  "item.minecraft.emerald": "kahurangi",
  "item.minecraft.item_frame": "item frame",
  "block.minecraft.flower_pot": "flower pot",
  "item.minecraft.carrot": "kāreti",
  "item.minecraft.potato": "rīwai",
  "item.minecraft.baked_potato": "baked potato",
  "item.minecraft.poisonous_potato": "poisonous potato",
  "item.minecraft.map": "empty map",
  "item.minecraft.golden_carrot": "golden carrot",
  "block.minecraft.skeleton_skull": "skeleton skull",
  "block.minecraft.wither_skeleton_skull": "wither skeleton skull",
  "block.minecraft.player_head": "player head",
  "block.minecraft.zombie_head": "zombie head",
  "block.minecraft.creeper_head": "te upoko o ponaturi",
  "block.minecraft.dragon_head": "upoko taniwha",
  "item.minecraft.carrot_on_a_stick": "carrot on a stick",
  "item.minecraft.warped_fungus_on_a_stick": "he harore i whakapikoa i runga i te rakau",
  "item.minecraft.nether_star": "nether star",
  "item.minecraft.pumpkin_pie": "pumpkin pie",
  "item.minecraft.firework_rocket": "firework rocket",
  "item.minecraft.firework_star": "firework star",
  "item.minecraft.enchanted_book": "enchanted book",
  "item.minecraft.nether_brick": "nether brick",
  "item.minecraft.quartz": "nether quartz",
  "item.minecraft.tnt_minecart": "minecart with tnt",
  "item.minecraft.hopper_minecart": "minecart with hopper",
  "item.minecraft.prismarine_shard": "prismarine shard",
  "item.minecraft.prismarine_crystals": "prismarine crystals",
  "item.minecraft.rabbit": "raw rabbit",
  "item.minecraft.cooked_rabbit": "cooked rabbit",
  "item.minecraft.rabbit_stew": "rabbit stew",
  "item.minecraft.rabbit_foot": "rabbit's foot",
  "item.minecraft.rabbit_hide": "rabbit hide",
  "item.minecraft.armor_stand": "armor stand",
  "item.minecraft.iron_horse_armor": "iron horse armor",
  "item.minecraft.golden_horse_armor": "golden horse armor",
  "item.minecraft.diamond_horse_armor": "diamond horse armor",
  "item.minecraft.leather_horse_armor": "te horo kihini",
  "item.minecraft.lead": "taura here",
  "item.minecraft.name_tag": "tohu ingoa",
  "item.minecraft.command_block_minecart": "minecart with command block",
  "item.minecraft.mutton": "raw mutton",
  "item.minecraft.cooked_mutton": "cooked mutton",
  "block.minecraft.white_banner": "white banner",
  "block.minecraft.orange_banner": "orange banner",
  "block.minecraft.magenta_banner": "magenta banner",
  "block.minecraft.light_blue_banner": "light blue banner",
  "block.minecraft.yellow_banner": "yellow banner",
  "block.minecraft.lime_banner": "lime banner",
  "block.minecraft.pink_banner": "pink banner",
  "block.minecraft.gray_banner": "gray banner",
  "block.minecraft.light_gray_banner": "light gray banner",
  "block.minecraft.cyan_banner": "paerangi cyan",
  "block.minecraft.purple_banner": "paerewa waiporoporo",
  "block.minecraft.blue_banner": "papa kahurangi",
  "block.minecraft.brown_banner": "paraone turanga",
  "block.minecraft.green_banner": "kaupapa kakariki",
  "block.minecraft.red_banner": "turanga whero",
  "block.minecraft.black_banner": "turanga pango",
  "item.minecraft.end_crystal": "end crystal",
  "item.minecraft.chorus_fruit": "chorus fruit",
  "item.minecraft.popped_chorus_fruit": "popped chorus fruit",
  "item.minecraft.beetroot": "beetroot",
  "item.minecraft.beetroot_seeds": "kākano rengakura",
  "item.minecraft.beetroot_soup": "beetroot soup",
  "item.minecraft.dragon_breath": "hā taniwha",
  "item.minecraft.splash_potion": "splash uncraftable potion□nga hua fov",
  "item.minecraft.spectral_arrow": "spectral arrow",
  "item.minecraft.tipped_arrow": "uncraftable tipped arrow□nga hua fov",
  "item.minecraft.lingering_potion": "lingering uncraftable potion□nga hua fov",
  "item.minecraft.shield": "shield",
  "item.minecraft.elytra": "pākau",
  "item.minecraft.spruce_boat": "spruce boat",
  "item.minecraft.birch_boat": "birch boat",
  "item.minecraft.jungle_boat": "jungle boat",
  "item.minecraft.acacia_boat": "acacia boat",
  "item.minecraft.dark_oak_boat": "dark oak boat",
  "item.minecraft.totem_of_undying": "totem of undying",
  "item.minecraft.shulker_shell": "shulker shell",
  "item.minecraft.iron_nugget": "iron nugget",
  "item.minecraft.knowledge_book": "knowledge book",
  "item.minecraft.debug_stick": "debug stick",
  "item.minecraft.music_disc_13": "music disc□c418 - 13",
  "item.minecraft.music_disc_cat": "music disc□c418 - cat",
  "item.minecraft.music_disc_blocks": "music disc□c418 - blocks",
  "item.minecraft.music_disc_chirp": "music disc□c418 - chirp",
  "item.minecraft.music_disc_far": "music disc□c418 - far",
  "item.minecraft.music_disc_mall": "music disc□c418 - mall",
  "item.minecraft.music_disc_mellohi": "music disc□c418 - mellohi",
  "item.minecraft.music_disc_stal": "music disc□c418 - stal",
  "item.minecraft.music_disc_strad": "music disc□c418 - strad",
  "item.minecraft.music_disc_ward": "music disc□c418 - ward",
  "item.minecraft.music_disc_11": "music disc□c418 - 11",
  "item.minecraft.music_disc_wait": "music disc□c418 - wait",
  "item.minecraft.music_disc_pigstep": "music disc□lena raine - pigstep",
  "item.minecraft.trident": "trident□□i te ringa matua:□+8 tukino whakaeke□-2.9 tere whakaeke",
  "item.minecraft.phantom_membrane": "phantom membrane",
  "item.minecraft.nautilus_shell": "nautilus shell",
  "item.minecraft.heart_of_the_sea": "heart of the sea",
  "item.minecraft.crossbow": "rangi tanora",
  "item.minecraft.suspicious_stew": "kakau kino",
  "block.minecraft.loom": "loom",
  "item.minecraft.flower_banner_pattern": "he hoahoa paewhiri□flower charge",
  "item.minecraft.creeper_banner_pattern": "he hoahoa paewhiri□kaitono kakau",
  "item.minecraft.skull_banner_pattern": "he hoahoa paewhiri□skull charge",
  "item.minecraft.mojang_banner_pattern": "he hoahoa paewhiri□thing",
  "item.minecraft.globe_banner_pattern": "he hoahoa paewhiri□ao",
  "item.minecraft.piglin_banner_pattern": "he hoahoa paewhiri□ngutu",
  "block.minecraft.composter": "kaiaka",
  "block.minecraft.barrel": "kāho",
  "block.minecraft.smoker": "kaipupuri",
  "block.minecraft.blast_furnace": "puhipuhi panuka",
  "block.minecraft.cartography_table": "ripanga whakaahua",
  "block.minecraft.fletching_table": "ripanga tuhipuhi",
  "block.minecraft.grindstone": "piritanga",
  "block.minecraft.lectern": "lectern",
  "block.minecraft.smithing_table": "papa ripanga",
  "block.minecraft.stonecutter": "korene",
  "block.minecraft.bell": "bell",
  "block.minecraft.lantern": "rama",
  "block.minecraft.soul_lantern": "wairua rama",
  "item.minecraft.sweet_berries": "sweet berries",
  "block.minecraft.campfire": "puke auahi",
  "block.minecraft.soul_campfire": "mura ahi wairua",
  "block.minecraft.shroomlight": "rama harore",
  "item.minecraft.honeycomb": "honikoma",
  "block.minecraft.bee_nest": "pī kohanga",
  "block.minecraft.beehive": "beehive",
  "item.minecraft.honey_bottle": "pounamu honi",
  "block.minecraft.honey_block": "honi poraka",
  "block.minecraft.honeycomb_block": "te honikoma poraka",
  "block.minecraft.lodestone": "toka autō",
  "block.minecraft.netherite_block": "tuhinga o mua",
  "block.minecraft.ancient_debris": "puehu onamata",
  "block.minecraft.target": "whaainga",
  "block.minecraft.crying_obsidian": "tangi obsidian",
  "block.minecraft.blackstone": "toka pango",
  "block.minecraft.blackstone_slab": "koura kohatu pango",
  "block.minecraft.blackstone_stairs": "koura kohatu pango arawhata",
  "block.minecraft.gilded_blackstone": "pounamu kua oro",
  "block.minecraft.polished_blackstone": "pounamu kua oro",
  "block.minecraft.polished_blackstone_slab": "papakahi pangoariki kua oro",
  "block.minecraft.polished_blackstone_stairs": "arawhata pango ngakou",
  "block.minecraft.chiseled_polished_blackstone": "chiseled pakihi pango",
  "block.minecraft.polished_blackstone_bricks": "nga pereki pounamu kua oro",
  "block.minecraft.polished_blackstone_brick_slab": "he papa papa pereki maaka",
  "block.minecraft.polished_blackstone_brick_stairs": "arawhata tawhata pango ngehe",
  "block.minecraft.cracked_polished_blackstone_bricks": "ngatata poraka pounamu maama",
  "block.minecraft.respawn_anchor": "te punga anga",
}
export const mi_nz = items; 
